// mon-budget-app/src/components/DebtCreditRow.jsx

import React from 'react';

// Mappage des statuts (Définition locale pour DebtCreditRow)
const statusTranslations = {
    'Pending': 'En Attente',
    'Partially Paid': 'Partiellement Payé',
    'Settled': 'Soldé'
};

const formatCurrency = (amount) => {
    return Number(amount).toLocaleString("fr-FR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

export default function DebtCreditRow({ item, type, isSelected, onSelect, styles }) {
    const isDebt = type === 'debt';
    
    // Le nom de l'autre personne (Créancier si c'est une dette, Débiteur si c'est une créance)
    const otherPersonName = isDebt ? item.creditor_name : item.debtor_name;
    
    // Logique de couleur pour le montant restant
    let remainingColor = 'gray';
    if (item.remaining_amount > 0.01) {
        remainingColor = isDebt ? 'red' : 'green';
    }

    // Détermine si la ligne est remboursée
    const isSettled = item.remaining_amount <= 0.01;
    
    // 💡 Déterminer le statut pour l'affichage (Soldé ou le statut réel de la BDD)
    const currentStatus = isSettled ? 'Settled' : item.status;
    
    // Traduction du statut
    const translatedStatus = statusTranslations[currentStatus] || currentStatus;

    return (
        <tr style={{ 
            backgroundColor: isSelected ? '#e6f7ff' : 'transparent', 
            opacity: isSettled ? 0.6 : 1, 
            cursor: 'pointer' 
        }}
        // 💡 Permet de cliquer sur la ligne pour sélectionner (mais pas sur la case si déjà soldé)
        onClick={isSettled ? null : () => onSelect(item.id)}
        >
            <td 
                style={styles.thCenter}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Case à cocher pour la sélection */}
                <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={(e) => onSelect(item.id)}
                    disabled={isSettled}
                    style={{cursor: 'pointer'}}
                />
            </td>
            
            {/* Colonne Débiteur/Créancier */}
            <td style={styles.th}>{otherPersonName}</td>
            
            {/* Colonne Facture/Description */}
            <td style={styles.th}>{item.facture_description}</td>
            
            {/* Colonne Date Origine */}
            <td style={styles.thCenter}>
                {new Date(item.facture_date).toLocaleDateString('fr-FR')}
            </td>
            
            {/* Colonne Montant Initial */}
            <td style={styles.thCenter}>{formatCurrency(item.original_amount)} €</td>
            
            {/* Colonne Montant Restant */}
            <td style={{ ...styles.thCenter, color: remainingColor, fontWeight: 'bold' }}>
                {isSettled ? translatedStatus : `${formatCurrency(item.remaining_amount)} €`}
            </td>

             {/* Colonne Statut - MISE À JOUR */}
            <td style={styles.thCenter}>
                <span style={{ 
                    padding: '3px 8px', 
                    borderRadius: '4px',
                    backgroundColor: currentStatus === 'Settled' ? '#d4edda' : (currentStatus === 'Partially Paid' ? '#fff3cd' : '#f8d7da'),
                    color: currentStatus === 'Settled' ? '#155724' : (currentStatus === 'Partially Paid' ? '#856404' : '#721c24'),
                    fontSize: '0.8em'
                }}>
                    {translatedStatus}
                </span>
            </td>
        </tr>
    );
}